/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Billing_Cycle_MonthlyInputs */

const en_admin_resources_billing_cycle_monthly = /** @type {(inputs: Admin_Resources_Billing_Cycle_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly`)
};

const de_admin_resources_billing_cycle_monthly = /** @type {(inputs: Admin_Resources_Billing_Cycle_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatlich`)
};

const es_admin_resources_billing_cycle_monthly = /** @type {(inputs: Admin_Resources_Billing_Cycle_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensualmente`)
};

const fr_admin_resources_billing_cycle_monthly = /** @type {(inputs: Admin_Resources_Billing_Cycle_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensuellement`)
};

const nl_admin_resources_billing_cycle_monthly = /** @type {(inputs: Admin_Resources_Billing_Cycle_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maandelijks`)
};

/** @type {(inputs: Admin_Resources_Billing_Cycle_MonthlyInputs) => LocalizedString} */
const it_admin_resources_billing_cycle_monthly = en_admin_resources_billing_cycle_monthly;

/** @type {(inputs: Admin_Resources_Billing_Cycle_MonthlyInputs) => LocalizedString} */
const pt_br2_admin_resources_billing_cycle_monthly = en_admin_resources_billing_cycle_monthly;

/** @type {(inputs: Admin_Resources_Billing_Cycle_MonthlyInputs) => LocalizedString} */
const pl_admin_resources_billing_cycle_monthly = en_admin_resources_billing_cycle_monthly;

/** @type {(inputs: Admin_Resources_Billing_Cycle_MonthlyInputs) => LocalizedString} */
const hu_admin_resources_billing_cycle_monthly = en_admin_resources_billing_cycle_monthly;

/** @type {(inputs: Admin_Resources_Billing_Cycle_MonthlyInputs) => LocalizedString} */
const ro_admin_resources_billing_cycle_monthly = en_admin_resources_billing_cycle_monthly;

/**
* | output |
* | --- |
* | "Monthly" |
*
* @param {Admin_Resources_Billing_Cycle_MonthlyInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_billing_cycle_monthly = /** @type {((inputs?: Admin_Resources_Billing_Cycle_MonthlyInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Billing_Cycle_MonthlyInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_billing_cycle_monthly(inputs)
	if (locale === "de") return de_admin_resources_billing_cycle_monthly(inputs)
	if (locale === "es") return es_admin_resources_billing_cycle_monthly(inputs)
	if (locale === "fr") return fr_admin_resources_billing_cycle_monthly(inputs)
	if (locale === "nl") return nl_admin_resources_billing_cycle_monthly(inputs)
	if (locale === "it") return it_admin_resources_billing_cycle_monthly(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_billing_cycle_monthly(inputs)
	if (locale === "pl") return pl_admin_resources_billing_cycle_monthly(inputs)
	if (locale === "hu") return hu_admin_resources_billing_cycle_monthly(inputs)
	return ro_admin_resources_billing_cycle_monthly(inputs)
});
export { admin_resources_billing_cycle_monthly as "admin.resources.billing_cycle_monthly" }